import { Box, Button, Grid, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import MoneyGram from 'assets/icons/payment-options/moneygram.svg';
import { PaymentProvider } from 'enums/paymentProviders';
import React, { useState } from 'react';
import { GrStripe } from 'react-icons/gr';
import { SiAmericanexpress } from 'react-icons/si';
import { PaymentOption } from 'store/url-builder';
import dashedButtonStyle from 'styles/buttons/dashed-button.module.scss';
import { PaymentOptionsDialog } from './payment-option-dialog';

const { Visa, Mastercard, Skrill, Paypal, Alipay, Applepay, Amex, Discover } = require('react-pay-icons');

export const getPaymentOptionIcon = (paymentOption: PaymentProvider, { width, height }: any) => {
 switch (paymentOption) {
  case PaymentProvider.Visa:
   return <Visa style={{ width, height }} />;
  case PaymentProvider.Mastercard:
   return <Mastercard style={{ width, height }} />;
  case PaymentProvider.Skrill:
   return <Skrill style={{ width, height }} />;
  case PaymentProvider.PayPal:
   return <Paypal style={{ width, height }} />;
  case PaymentProvider.Alipay:
   return <Alipay style={{ width, height }} />;
  case PaymentProvider.Applepay:
   return <Applepay style={{ width, height }} />;
  case PaymentProvider.Stripe:
   return <GrStripe style={{ width, height, color: '#6772E5' }} />;
  case PaymentProvider.MoneyGram:
   return <img src={MoneyGram} alt='Moneygram' height={height} width={width} style={{ objectFit: 'cover' }} />;
   case PaymentProvider.Amex:
    return <Amex style={{ width, height }}/>;
   case PaymentProvider.Discover:
    return <Discover style={{ width, height }}/>;
   }
};

interface PaymentOptionListProps {
 paymentOptions: PaymentOption[];
 readonly?: boolean;
 onItemClick?(paymentOption: PaymentOption): void;
 builderType: string;
}

export const PaymentOptionList = ({ paymentOptions, readonly, onItemClick, builderType }: PaymentOptionListProps) => {
 const [openDialog, setOpenDialog] = useState(false);

 return (
  <Grid item container xs={12}>
   {!readonly && (
    <Grid item xs={12} className='mb-4'>
     <Button onClick={() => setOpenDialog(true)} classes={{ root: dashedButtonStyle.root }} fullWidth>
      <AddIcon /> Add payment option
     </Button>
    </Grid>
   )}
   <Grid container spacing={1}>
    {paymentOptions.map((option, index) => {
     return (
      <Grid item key={option.name + index} onClick={() => onItemClick && onItemClick(option)}>
       <Box display='flex' justifyContent='center'>
        {getPaymentOptionIcon(option.name, { width: '50px', height: '50px' })}
       </Box>
      </Grid>
     );
    })}
   </Grid>
   {openDialog && <PaymentOptionsDialog preselected={paymentOptions} isOpen onClose={() => setOpenDialog(false)} builderType={builderType}/>}
  </Grid>
 );
};
